import _ from 'lodash';

import CMSModel from '@/visa-application/models/CMSModel';
import CountryCMSModel from '@/visa-application/models/CountryCMSModel';
import ApplicationCenterCMSModel from '@/visa-application/models/ApplicationCenterCMSModel';

export default class CustomPageCMSModel implements CMSModel {
  country: CountryCMSModel = new CountryCMSModel();
  application_center: ApplicationCenterCMSModel = new ApplicationCenterCMSModel();
  title = '';
  primary_sub_title = '';
  subtitle = '';
  card_title = '';
  content_title = '';
  content = '';
  meta_title = '';
  meta_description = '';
  meta_keywords = '';

  map(obj: any): void {
    this.country.map(_.get(obj, 'country', {}));
    this.application_center.map(_.get(obj, 'application_center', {}));
    this.title = _.get(obj, 'translation[0].title', '');
    this.subtitle = _.get(obj, 'translation[0].subtitle', '');
    this.card_title = _.get(obj, 'translation[0].card_title', '');
    this.content_title = _.get(obj, 'translation[0].content_title', '');
    this.content = _.get(obj, 'translation[0].content', '');
    this.primary_sub_title = _.get(obj, 'translation[0].primary_sub_title', '');
    this.meta_title = _.get(obj, 'translation[0].meta_title', '');
    this.meta_description = _.get(obj, 'translation[0].meta_description', '');
    this.meta_keywords = _.get(obj, 'translation[0].meta_keywords', '');
  }
}
